var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup14871(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.882,
    height: 20.867,
    viewBox: "0 0 20.882 20.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke-width:1.5px;}.a,.c{stroke:#002cfa;}.b{fill:#fdfdff;}.c{fill:#002cfa;stroke-width:0.5px;}.d{stroke:none;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-676 -262.633)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(676 267.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 16,
    height: 16,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2.25
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.101,
    cy: 5.101,
    r: 5.101,
    transform: "matrix(-0.788, 0.616, -0.616, -0.788, 696.882, 270.673)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679.993 268.383)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.993 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.859,182.839,3.2,184.5a1.764,1.764,0,0,1-2.5-2.5l3.327-3.327a1.764,1.764,0,0,1,2.5,0,.588.588,0,0,0,.832-.832,2.941,2.941,0,0,0-4.159,0l-3.327,3.327a2.941,2.941,0,1,0,4.159,4.159l1.663-1.663a.588.588,0,1,0-.832-.832Z",
    transform: "translate(0.993 -172.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M197.927-.139a2.941,2.941,0,0,0-4.159,0l-2,2a.588.588,0,0,0,.832.832l2-2a1.764,1.764,0,1,1,2.5,2.5l-3.66,3.66a1.764,1.764,0,0,1-2.5,0,.588.588,0,1,0-.832.832,2.941,2.941,0,0,0,4.159,0l3.66-3.66A2.941,2.941,0,0,0,197.927-.139Z",
    transform: "translate(-184.671 1)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14871);
export default __webpack_public_path__ + "static/media/group-14871.8e6fa41fb0fe7c1a4bea67e9089e29f6.svg";
export { ForwardRef as ReactComponent };